<template>
    <div>
        <div class="title">
            <h1> OTHER WAYS TO KNOW ME </h1>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6" >
                    <div class="grid-content">
                        <div class="image-salon"></div>
                    </div>
                </el-col>
                <el-col :span="14" style="height: 20vw">
                    <div class="grid-content content-text">
                        <h1>Academic Salon</h1>
                        <h2>
                            I was invited to give an academic salon talk at the Future Design Forum titled “The Distance Between Us and ‘Ready Player One’: How Haptics Reshapes the Perception Boundary of Virtual Reality.”
                        </h2>
                        <div class="BTN">
                            <a target="_blank" href="https://www.yuque.com/ogongqingo/fac2z4/flanr5gvwq0k498n">
                                <input class="detailBTN" type="button" value="LEARN MORE">
                            </a>
                        </div>
                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6" >
                    <div class="grid-content">
                        <div class="image1"></div>
                    </div>
                </el-col>
                <el-col :span="14" style="height: 20vw">
                    <div class="grid-content content-text">
                        <h1>Design Research Public Speaking</h1>
                        <h2>
                            I was invited to give a speech on design research related topics in "21 Design". "21 Design" is a pure public welfare sharing and exchange platform for design research funded by the Industrial Design Branch of the Chinese Mechanical Engineering Society. It focuses on the most cutting-edge design direction, invites scholars with certain achievements to create and share experiences, and helps young people who are interested in design research to grow together.
                        </h2>
                        <div class="BTN">
                            <a target="_blank" href="https://www.yuque.com/ogongqingo/fac2z4/hrg5ck">
                                <input class="detailBTN" type="button" value="LEARN MORE">
                            </a>
                        </div>
                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6" >
                    <div class="grid-content">
                        <div class="image3"></div>
                    </div>
                </el-col>
                <el-col :span="14" style="height: 20vw">
                    <div class="grid-content content-text">
                        <h1>Development technology sharing</h1>
                        <h2> I have uploaded some development videos of VR eye-tracking foveated rendering related functions on the personal account of the Bilibili video website, and wrote a development method document on the Yuque platform to share. These have helped other developers and enthusiasts and gained recognition.</h2>
                        <div class="BTN">
                            <a target="_blank" href="https://www.bilibili.com/video/BV1FL41157F2/?spm_id_from=333.999.0.0&vd_source=95cb2f19566155bb73393c4156455e36">
                                <input class="detailBTN" type="button" value="BILIBILI">
                            </a>
                            <a target="_blank" href="https://www.yuque.com/ogongqingo/fac2z4/yu9vb3">
                                <input class="detailBTN" type="button" value="YUQUE DOCUMENT">
                            </a>
                        </div>
                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Media"
    }
</script>

<style scoped>
    h1{
        font-size: 25px;
        font-weight: 400;
        color: #333;
    }
    h2{
        font-size: 15px;
        font-weight: 100;
        line-height: 25px;
        color: #666;
    }
    .BTN{

    }
    .detailBTN{
        margin-right: 10px;
        margin-top: 2px;
        cursor:pointer;
        width: 150px;
        height: 50px;
        background-color: #333;
        color: #fff;
        border: none;
    }
    .detailBTN:hover{
        opacity: 80%;
    }
    .content{
        margin-top: 100px;
        width: 100%;
        height: 20vw;
    }
    .content-text{
        margin-left: 4vw;
        margin-top: -25px;
    }
    .image-salon{
        width: 100%;
        height: 20vw;
        background-color: #000;
        background-image: url("../assets/media3.jpeg.webp");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    .image1{
        width: 100%;
        height: 20vw;
        background-image: url("../assets/publicspeaking.jpg.webp");
        background-position: center;
        background-size: cover;
    }
    .image2{
        width: 100%;
        height: 20vw;
        background-image: url("../assets/blog.png.webp");
        background-position: center;
        background-size: cover;
    }
    .image3{
        width: 100%;
        height: 20vw;
        background-image: url("../assets/vreye_homepage.jpg.webp");
        background-position: center;
        background-size: cover;
    }
    .grid-content{
        min-height: 36px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>